export { default } from './ReviewRating';
export type { IReviewRatingProps } from './ReviewRating';
